export default "__VITE_ASSET__o9noNiIg__"